import React from "react";
import { REMOTE_URLS } from "../../../constants";
import { loadRemoteModule } from "../../../util/loadRemoteModule";

export type SppPlayerProps = {
  url: string;
  onReady?: () => void;
  isAudioPlayer?: boolean;
  loadingAspectRatio?: boolean;
  environment?: string;
};

type RemoteSppLazyComponent = React.LazyExoticComponent<React.ComponentType<SppPlayerProps>>;

const remoteSPPCache: Record<string, RemoteSppLazyComponent> = {};

function createRemoteSPP(env: string | undefined): RemoteSppLazyComponent {
  const remoteUrls = REMOTE_URLS[env ?? "dev"] ?? REMOTE_URLS["dev"];

  console.log("remoteUrls", remoteUrls);

  return React.lazy(() =>
    loadRemoteModule(remoteUrls.cloudflicks, "cloudflicks", "./SPPPlayer").catch((err) => {
      console.error("❌ Error loading cloudflicks/SPPPlayer:", err);
      console.error("   Error type:", err?.constructor?.name || typeof err);
      console.error("   Error message:", err?.message || String(err));
      if (err?.stack) {
        console.error("   Error stack:", err?.stack);
      }

      if (err?.message?.includes("Failed to fetch") || err?.message?.includes("CORS")) {
        console.error("   ⚠️  This appears to be a network/CORS issue. Check:");
        console.error("      - Is the remote URL accessible?");
        console.error("      - Are CORS headers configured on the remote server?");
        console.error("      - Is the remoteEntry.js file loading correctly?");
      }

      if (
        err?.message?.includes("Shared module") ||
        err?.message?.includes("version") ||
        err?.message?.includes("React")
      ) {
        console.error("   ⚠️  This appears to be a Module Federation shared dependency issue.");
        console.error("      - Check React version compatibility");
        console.error("      - Verify shared dependencies configuration");
      }

      return {
        default: ({ url }: SppPlayerProps) => (
          <div
            className="video-error"
            style={{
              padding: "1rem",
              border: "1px solid #ff6b6b",
              borderRadius: "4px",
              backgroundColor: "#fff5f5",
            }}
          >
            <p>
              <strong>Failed to load video player</strong>
            </p>
            <p style={{ fontSize: "0.875rem", marginTop: "0.5rem" }}>
              The video player could not be loaded. Please check your Module Federation
              configuration.
            </p>
            {url && (
              <p style={{ fontSize: "0.75rem", marginTop: "0.5rem", color: "#666" }}>
                Video URL: {url}
              </p>
            )}
          </div>
        ),
      } as { default: React.ComponentType<SppPlayerProps> };
    }),
  ) as RemoteSppLazyComponent;
}

export function getRemoteSPP(env: string): RemoteSppLazyComponent {
  if (!remoteSPPCache[env]) {
    remoteSPPCache[env] = createRemoteSPP(env);
  }
  return remoteSPPCache[env];
}
